export default "__VITE_ASSET__Dhu8Mbwt__"